import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import { Toast } from 'vant'
import axios from 'axios'
import store from '../store'

Vue.use(VueRouter)

const routes = [
        {
            path: '/',
            name: 'Home',
            component: Home,
            meta:{
                title: 'MoreFun GameHub'
            },
            beforeEnter: requireParams
        },
        {
            path: '/home',
            name: 'Home',
            component: Home,
            meta:{
                title: 'MoreFun GameHub'
            },
        },
        {
            path: '/discuss',
            name: 'Discuss',
            component: () => import('../views/Discuss.vue'),
            meta:{
                title: 'MoreFun GameHub'
            },
            beforeEnter: requireParams
        },
        {
            path: '/myInfo',
            name: 'MyInfo',
            component: () => import('../views/MyInfo.vue'),
            meta:{
                title: 'MoreFun GameHub'
            },
            beforeEnter: requireParams
        },
        {
            path: '/postPublish',
            name: 'PostPublish',
            component: () => import('../views/PostPublish.vue'),
            meta:{
                title: 'MoreFun GameHub'
            },
            beforeEnter: requireParams
        },
        {
            path: '/postDetail/:id',
            name: 'PostDetail',
            component: () => import('../views/PostDetail.vue'),
            meta:{
                title: 'MoreFun GameHub'
            },
            beforeEnter: requireParams
        },
        {
            path: '/error',
            name: 'Error',
            component: () => import('../views/Error.vue'),
            meta:{
                title: 'MoreFun GameHub'
            }
        },
    ]
 
function requireParams (to, from ,next) {
    
    if(to.path !== '/') {
        Vue.prototype.isCur = false;
    } else {
        Vue.prototype.isLeftLine = false;
        Vue.prototype.isRightLine = true
    }


    if(to.path == '/myInfo') {
        Vue.prototype.isLeftLine = true;
        Vue.prototype.isRightLine = false
    }

    if(to.path == '/postPublish' || to.path.indexOf('/postDetail') !== -1) {
        Vue.prototype.isActive = true;
    } else {
        Vue.prototype.isActive = false;
    }
    
    if(Vue.prototype.hasLogin) {
        
        next()

    } else {
        let obj = new Object();
        obj.username = Vue.prototype.$utils.getUrlKey('username'),
        obj.uid = Vue.prototype.$utils.getUrlKey('uid');
        obj.app_id = Vue.prototype.$utils.getUrlKey('app_id');
        obj.app_name = Vue.prototype.$utils.getUrlKey('app_name');
        obj.sname = Vue.prototype.$utils.getUrlKey('sname');
        obj.role = Vue.prototype.$utils.getUrlKey('role');

        if(obj.uid == 'unknown' || obj.username == 'unknown' || obj.app_id == 'unknown' || obj.app_name == 'unknown' || obj.sname == 'unknown' || obj.role == 'unknown' || obj.uid == undefined || obj.username == undefined || obj.app_id == undefined || obj.app_name == undefined || obj.sname == undefined || obj.role == undefined) {
            router.push('/error')
        } else {

            let api = '/appUser/get';
            Vue.prototype.$http.get(api, {
                params: {
                    'username': obj.username,
                    'uid': obj.uid,
                    'app_id': obj.app_id,
                    'app_name': obj.app_name,
                    'sname': obj.sname,
                    'role_name': obj.role
                }
            }).then((response) => {
                    // console.log('gameId',Vue.prototype.game_id);
                    store.commit('saveUserInfo',response.data);
                    Vue.prototype.hasLogin = true;
                    store.commit('isLogin');
                    next();

                }).catch((error) => {
                    return false
                });
            }
    }
}

function getUserInfoParams (username, uid, app_id, app_name, sname, role_name) {
    let api = '/appUser/get';
    axios.get(api, {
        params: {
            'username': username,
            'uid': uid,
            'app_id': app_id,
            'app_name': app_name,
            'sname': sname,
            'role_name': role_name
        }
    }).then((response) => {

            store.commit('saveUserInfo',response.data);
            Vue.prototype.hasLogin = true;
            store.commit('isLogin');

        }).catch((error) => {
            // Toast("系统错误！");
            return false
        });
}

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    linkExactActiveClass:'active',
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {
                x: 0,
                y: 0
            }
        }
    }
})

export default router